<template>

	<section id="Home">

		<div id="Menu">

			<div class="menu-el menu-el--metrology">

				<a @click="onClick('metrology', '/metrology')">

					{{ $t('metrology') }}

				</a>

				<br />

				<div class="touch-effect" :class="{show: effect.metrology}"></div>

			</div>

			<div class="menu-el menu-el--inspection">

				<a @click="onClick('inspection', '/inspection')">

					{{ $t('inspection') }}

				</a>

				<br />

				<div class="touch-effect" :class="{show: effect.inspection}"></div>

			</div>

			<div class="menu-el menu-el--analysis">

				<a @click="onClick('analysis', '/analysis')">

					{{ $t('analysis') }}

				</a>

				<br />

				<div class="touch-effect" :class="{show: effect.analysis}"></div>

			</div>

			<div class="menu-el menu-el--applications">

				<a @click="onClick('applications', '/applications')">

					{{ $t('applications') }}

				</a>

				<br />

				<div class="touch-effect" :class="{show: effect.applications}"></div>

			</div>

			<div class="menu-el menu-el--x-ray_series">

				<a @click="onClick('xrayseries', '/x-ray_series')">

					{{ $t('xraySeries') }}

				</a>

				<br />

				<div class="touch-effect" :class="{show: effect.xrayseries}"></div>

			</div>

		</div>

	</section>

</template>

<script>

	export default {
		data () {
			return {
				effect: {
					'metrology': false,
					'inspection': false,
					'analysis': false,
					'applications': false,
					'xrayseries': false
				}
			};
		},
		methods: {
			onClick (element, href) {
				this.effect[element] = true;
				setTimeout(() => {
					this.$router.push(href);
				}, 750);
			}
		}
	};

</script>